import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as api from "@/lib/api";

export function useComments(articleId: string, sort = "newest") {
  return useQuery({
    queryKey: ["comments", articleId, sort],
    queryFn: () => api.listComments(articleId, sort),
    enabled: !!articleId,
  });
}

export function useCreateComment(articleId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      commenterAddress,
      body,
      parentId,
      jwt,
    }: {
      commenterAddress: string;
      body: string;
      parentId?: string;
      jwt?: string;
    }) => api.createComment(articleId, commenterAddress, body, parentId, jwt),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["comments", articleId] });
    },
  });
}

export function useDeleteComment(articleId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      commentId,
      commenterAddress,
      jwt,
    }: {
      commentId: string;
      commenterAddress: string;
      jwt?: string;
    }) => api.deleteComment(commentId, commenterAddress, jwt),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["comments", articleId] });
    },
  });
}

export function useLikeComment(articleId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      commentId,
      likerAddress,
      jwt,
    }: {
      commentId: string;
      likerAddress: string;
      jwt?: string;
    }) => api.likeComment(commentId, likerAddress, jwt),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["comments", articleId] });
    },
  });
}
